import createFileSystemReducerWithNamedType from 'store/hoReducers/fileSystem/reducer';
import initialState from './initialState';

export default createFileSystemReducerWithNamedType('RESOURCES', initialState);
